module.exports = __webpack_public_path__ + "static/media/everest_logo.34e173cb.png";